module.exports = __webpack_public_path__ + "img/standby-options-marked.3e9efaf8.png";